// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"88":"a6846f4b","223":"4b5e0c0f","563":"db7d5ef7","574":"fcaa6062"}[chunkId] + ".chunk.js");